/* global VXConfig */

import React                     from 'react';
import PropTypes                 from "prop-types";
import Translations              from "../../utils/Translations";
import withDildocontrolGiftTiles from "../HigherOrderComponents/Dildocontrol/withDildocontrolGiftTiles";

class DildocontrolInfoPopup extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const closeButton = VXConfig.isVXMobilePlatform ?
			<div className="dildocontrol-info-popup__close-button icon -icon-close-line" onClick={this.props.onTogglePopup} /> : null;

		const popupOnClickHandler = VXConfig.isVXMobilePlatform ? undefined : this.props.onTogglePopup;

		return (
			<div className="dildocontrol-info-popup__container">
				<div className="dildocontrol-info-popup__backdrop" onClick={this.props.onTogglePopup}></div>

				<div className="dildocontrol-info-popup__content" onClick={popupOnClickHandler}>
					{closeButton}

					<h3 className="dildocontrol-info-popup__header">
						<img className="dildocontrol-info-popup__header-logo"
						     src="/assets/img/dildocontrol/dildocontrol-icon-colored.png"
						/>{Translations.get('DildocontrolInfoPopupHeaderPart1')}{VXConfig.isVXMobilePlatform ?
							<br /> : ' '}{Translations.get('DildocontrolInfoPopupHeaderPart2')}
					</h3>

					<p className="dildocontrol-info-popup__body">{Translations.get('DildocontrolInfoPopupBody')}</p>

					<div className="dildocontrol-info-popup__gifts-overview">
						{this.props.dildocontrolGiftTiles}
					</div>
				</div>
			</div>
		);
	}
}

DildocontrolInfoPopup.propTypes = {
	onTogglePopup:         PropTypes.func.isRequired,
	dildocontrolGiftTiles: PropTypes.array.isRequired,
};

const DildocontrolInfoPopupWithTiles = withDildocontrolGiftTiles(DildocontrolInfoPopup);

export default DildocontrolInfoPopupWithTiles;